export type LegalSection = {
  title: string;
  body: string;
};

export type LegalPage = {
  intro: string;
  lastUpdated: string;
  sections: LegalSection[];
};

const LAST_UPDATED = '21/01/2025';

export const termsPage: LegalPage = {
  intro: 'Please read these terms and conditions carefully before using the Narvan plant care app.',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: 'Acceptance of Terms',
      body: 'By accessing or using Narvan, you agree to be bound by these terms and conditions. If you do not agree with any part of these terms, please do not use the app.',
    },
    {
      title: 'Use of the App',
      body: 'Narvan is intended for personal, non-commercial use. You may not modify, reproduce, or distribute any content from the app without our explicit permission.',
    },
    {
      title: 'User Account',
      body: 'To use certain features of Narvan, you may need to create a user account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.',
    },
    {
      title: 'Plant Care Reminders',
      body: "Narvan provides plant care reminders based on scanned QR codes. While we strive to provide accurate information, it is the user's responsibility to verify and ensure the proper care of their plants.",
    },
    {
      title: 'User Responsibilities',
      body: 'Users are responsible for the accuracy of the information they provide, including email addresses. You agree not to use Narvan for any unlawful or unauthorized purpose.',
    },
    {
      title: 'Geographical Limitation',
      body: 'Narvan is designed for users in the United Kingdom. Usage outside the UK may be subject to additional terms and conditions.',
    },
    {
      title: 'Modifications to the App',
      body: 'We reserve the right to modify or discontinue Narvan at any time. We are not liable for any modification, suspension, or discontinuation of the app.',
    },
    {
      title: 'Limitation of Liability',
      body: 'We are not liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of Narvan.',
    },
    {
      title: 'Changes to Terms',
      body: 'We may update these terms and conditions from time to time. Any changes will be effective immediately upon posting. Your continued use of Narvan after changes it means your acceptance of the updated terms.',
    },
    {
      title: 'Contact Us',
      body: 'If you have any questions or concerns regarding these terms and conditions, please contact us at privacy@narvan.co.uk.',
    },
  ],
};

export const privacyPage: LegalPage = {
  intro: 'This Privacy Policy explains how we collect, use and safeguard your information. By using the Narvan Houseplants mobile apps and websites, you agree to the terms outlined in this Privacy Policy.',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: 'Information We Collect',
      body: 'We collect only the email address during the account creation process. This information is used for account management purposes and is deleted when the user decides to delete their account.',
    },
    {
      title: 'Plant Care Reminders',
      body: 'Narvan provides plant care reminders based on scanned QR codes. The app sends periodic notifications to remind users to water and feed their plants. Users have the option to set, turn off, or modify these reminders.',
    },
    {
      title: 'User Rights',
      body: 'Users have the right to delete their account, which results in the deletion of associated email information. If users have any concerns about their privacy, they can contact us using the provided contact details.',
    },
    {
      title: 'Geographical Limitation',
      body: 'Narvan is designed for users in the United Kingdom. If you are located outside the UK, please be aware that your data may be transferred to and processed in the UK',
    },
    {
      title: 'Contact',
      body: 'If you have any questions, concerns, or feedback regarding your privacy or this Privacy Policy, please contact us at privacy@narvan.co.uk.',
    },
    {
      title: 'Changes to this Policy',
      body: "We may update our Privacy Policy from time to time. Any changes will be posted here, and it's your responsibility to review this policy occasionally.",
    },
  ],
};
